import { CustomerAPI } from 'api'

export const updateUserProperties = (
  userId: number,
  properties: Record<string, number | boolean | string>
) => {
  return CustomerAPI.patch<Record<string, number | boolean | string>>(
    `/users/${userId}/properties`,
    properties
  )
}

export const fetchEndUserAttributes = async (orgId: number) =>
  CustomerAPI.get(`organizations/${orgId}/end_users/attributes2`, {
    params: { playbookEventInclude: false },
  })
